import { useT, Namespace } from "@racoon/i18n";
import { cn } from "@racoon/ui";
import { SettingsTab } from "../model/useSettingsTabs";

interface SettingsTabsProps {
  activeTab: SettingsTab;
  tabs: SettingsTab[];
  onTabChange: (tab: SettingsTab) => void;
}

export function SettingsTabs({ activeTab, tabs, onTabChange }: SettingsTabsProps) {
  const t = useT();

  const tabLabels = {
    general: t(Namespace.Settings, "tabs.general"),
    notifications: t(Namespace.Settings, "tabs.notifications"),
    depot: t(Namespace.Settings, "tabs.depot"),
    job_types: t(Namespace.Settings, "tabs.job_types"),
    pickup_location_types: t(Namespace.Settings, "tabs.pickup_location_types"),
    bunkerType: t(Namespace.Settings, "tabs.bunkerType"),
    customer_types: t(Namespace.Settings, "tabs.customer_types"),
    truck_types: t(Namespace.Settings, "tabs.truck_types"),
    access_groups: t(Namespace.Settings, "tabs.access_groups"),
    teams: t(Namespace.Settings, "tabs.teams"),
  } satisfies Record<SettingsTab, string>;

  return (
    <nav
      role="tablist"
      aria-label="Tabs"
      aria-orientation="vertical"
      className="flex w-[200px] shrink-0 flex-col gap-1 overflow-y-auto border-r border-slate-200 p-2"
    >
      {tabs.map((tab) => {
        const active = activeTab === tab;
        return (
          <button
            key={tab}
            id={`settings-tab-${tab}-button`}
            type="button"
            role="tab"
            aria-selected={active}
            aria-controls="settings-tab-panel"
            onClick={() => onTabChange(tab)}
            className={cn(
              "w-full rounded-lg p-2 text-left text-sm leading-4",
              active
                ? "bg-blue-600 font-medium tracking-[-0.2px] text-white"
                : "tracking-[-0.01px] text-text-body hover:bg-slate-100",
            )}
          >
            {tabLabels[tab]}
          </button>
        );
      })}
    </nav>
  );
}
